<app-peptide-therapy
  htmlTitle="<strong>Enhance</strong> Hair Growth & Scalp Health with Peptide Therapy"
  question="Would you like to add Peptide Therapy for the most complete results?"
  [options]="options"
>
  <p class="mb-4">
    Hair loss is influenced by more than genetics. Inflammation, circulation, and slowed cellular repair can all limit
    results from standard treatments. Peptide therapy helps optimize scalp health and follicle function, creating a
    better environment for hair regrowth.
  </p>
  <ul class="mb-4">
    <li>
      <strong>BPC-157</strong> helps reduce inflammation and supports blood vessel and tissue repair, improving nutrient
      delivery to hair follicles.
    </li>
    <li>
      <strong>CJC-1295/Ipamorelin</strong> supports growth hormone signaling, recovery, and cellular repair—key
      processes for follicle health and hair vitality.
    </li>
    <li>
      <strong>GHK-Cu</strong> supports circulation, collagen production, and scalp repair, and is well known for its
      role in supporting hair quality and follicle strength.
    </li>
  </ul>
  <p class="mb-4">
    Many men add peptides to their hair loss plan to improve scalp health, support stronger regrowth, and maximize
    treatment results.
  </p>
</app-peptide-therapy>
